import { forwardRef } from "react";
import type { ButtonHTMLAttributes } from "react";

/** Porté à l'identique depuis apps/web/components/ui/Button.tsx (aucune dépendance Next.js dans l'original). */
export type ButtonVariant = "primary" | "secondary";
export type ButtonSize = "md" | "sm";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** primaire/or (action principale) ou secondaire/contour. */
  variant?: ButtonVariant;
  size?: ButtonSize;
}

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary:
    "border border-gold bg-gold text-navy hover:border-gold2 hover:bg-gold2 focus-visible:outline-gold",
  secondary:
    "border border-navy bg-transparent text-navy hover:bg-navy hover:text-cream focus-visible:outline-navy",
};

const SIZE_CLASSES: Record<ButtonSize, string> = {
  md: "px-6 py-3 text-sm",
  sm: "px-4 py-2 text-xs",
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "primary", size = "md", className = "", type = "button", ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={[
        "inline-flex items-center justify-center gap-2 rounded-sm font-body font-medium uppercase tracking-wide",
        "transition-colors duration-150",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        className,
      ].join(" ")}
      {...props}
    />
  );
});
